var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.333 2.547l-1.88-1.88L9.999 8.12 2.546.667l-1.88 1.88L8.119 10 .666 17.453l1.88 1.88 7.453-7.453 7.454 7.453 1.88-1.88L11.879 10l7.454-7.453z",
    fill: "#150223"
  })));
}
export default SvgCloseModal;